<button nz-button nzType="primary" (click)='showModal()' class='add'>
    Add Details
</button>

<nz-modal [nzVisible]="isVisible" [nzStyle]="styleObject" [nzFooter]='null'
    [nzBodyStyle]="{height:'400px', 'background-color': 'rgb(0 0 0 / 30%)', border: '1px solid #eee'}"
    [nzClosable]="true" (nzOnCancel)="handleCancel()">

    <form nz-form *nzModalContent> <br><br>

        <nz-form-item class='formitem1'>
            <nz-form-label nzFor="Name"> Name</nz-form-label>
            <nz-form-control [nzSm]="15">
                <input nz-input name='Name' [(ngModel)]="Name" type="text" />
            </nz-form-control>

        </nz-form-item>

        <nz-form-item class='formitem1'>
            <nz-form-label nzFor="Email"> Email </nz-form-label>
            <nz-form-control [nzSm]="15" [nzXs]="24">
                <input nz-input name='Email' [(ngModel)]="Email" type="text" />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item class='formitem1'>
            <nz-form-label nzFor="Email"> Password </nz-form-label>
            <nz-form-control [nzSm]="15">
                <input nz-input name='Password' [(ngModel)]="Password" type="password" />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item class='formitem1'>
            <nz-form-label [nzSm]="3" nzFor="Role"> Role </nz-form-label>
            <nz-form-control [nzSm]="15">
                <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a person" [(ngModel)]="Role"
                    [ngModelOptions]="{standalone: true}">
                    <nz-option nzLabel="Admin" nzValue="admin"></nz-option>
                    <nz-option nzLabel="Manager" nzValue="manager"></nz-option>

                </nz-select>

            </nz-form-control>
        </nz-form-item>


        <div>
            <button nz-button nzType="primary" class='button' (click)='createRecord()'> Add User</button>
            <button nz-button nzType="primary" class='button1' (click)='handleCancel()'>Cancel</button>
        </div>
    </form>

</nz-modal>



<div style="position: relative;top:50px;width:100% ">
    <h2 style='text-align: center;'> User Details</h2>
    <nz-table #editRowTable nzBordered [nzData]="userDetails" class="table">
        <thead class="hello">
            <tr>
                <th nzAlign='center'> Name </th>
                <th nzAlign='center'> Email</th>
                <th nzAlign='center'> Role</th>
                <th nzAlign='center'> Status </th>
                <th nzAlign='center'> Created_at </th>
                <th nzAlign='center'> Actions</th>

            </tr>
        </thead>
        <tbody class="'tbody">
            <tr *ngFor="let data of editRowTable.data;let i=index">
                <ng-container>
                    <td nzAlign='center'> {{data.name}}</td>
                    <td nzAlign='center'>{{data.email}}</td>
                    <td nzAlign='center'>{{data.role| titlecase}}</td>
                    <td nzAlign='center'> {{data.status |titlecase}}</td>
                    <td nzAlign='center'> {{data.created}}</td>
                    <td nzAlign='center'>
                        <button nz-button nzType="primary" (click)='EditUser(data)'> Edit User </button>
                        <button nz-button nzType="primary" nz-popconfirm nzPopconfirmTitle="Are you Sure Delete?"
                            (nzOnConfirm)='Delete(data)' nzPopconfirmPlacement="top" style="margin-left: 3px;">
                            Delete </button>
                    </td>
                </ng-container>

                <nz-modal [nzStyle]="styleObject" [nzFooter]='null' [nzVisible]="editVisible"
                    [nzBodyStyle]="{height:'300px', 'background-color': 'rgb(0 0 0 / 30%)'}" [nzClosable]="true"
                    (nzOnCancel)="handleCancel()">
                    <div>
                        Edit Employee
                    </div>
                    <form nz-form *nzModalContent [formGroup]="frmRegister" (ngSubmit)='updateUser(frmRegister.value)'>
                        <br><br>
                        <!-- 
                        <nz-form-item class='formitem1'>
                            <nz-form-label nzFor="Name"> Name</nz-form-label>
                            <nz-form-control [nzSm]="8">
                                <input nz-input name='Name' formControlName="name" type="text" />
                            </nz-form-control>

                        </nz-form-item>

                        <nz-form-item class='formitem1'>
                            <nz-form-label nzFor="Email"> Email </nz-form-label>
                            <nz-form-control [nzSm]="8">
                                <input nz-input name='Email' formControlName="email" type="text" />
                            </nz-form-control>

                        </nz-form-item>
 -->
                        <nz-form-item class='formitem1'>
                            <nz-form-label nzFor="Role"> Role </nz-form-label>
                            <nz-form-control [nzSm]="12" [nzXs]="24">
                                <nz-select formControlName="role">
                                    <nz-option nzLabel="Admin" nzValue="admin"></nz-option>
                                    <nz-option nzLabel="Manager" nzValue="manager"></nz-option>
                                </nz-select>

                            </nz-form-control>

                        </nz-form-item>

                        <div>
                            <button nz-button nzType="primary" class='button'> Update User</button>
                            <button nz-button nzType="primary" class='button1' (click)='handleCancel()'>Cancel</button>
                        </div>
                    </form>
                </nz-modal>


            </tr>


        </tbody>
    </nz-table>

</div>